<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Discount

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">


                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName">Total Bill Amount</label>
                      </div>

                      <div class="col-md-4">
                        <label class="margin-bottom-0px margin-left-5px">{{TotalBill}}</label>


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName">Previous Discount</label>
                      </div>

                      <div class="col-md-4">
                        <label class="margin-bottom-0px margin-left-5px">{{PreviousDiscount}}</label>


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px blue">
                        <label for="firstName">Is Discount in '%' or 'Fixed'?</label>
                      </div>
                      <div class="col-md-4">
                        <CodeTypeValue CodeType="DISCPF"
                                       id="idDiscPercentageOrFixed"
                                       [(ngModel)]="DiscountPercentOrFixedType" SelectedValue=""
                                       name="idDiscPercentageOrFixed"
                                       (keyChange)="DiscountTypeChange($event)"
                                       >
                        </CodeTypeValue>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row" *ngIf="DiscountPercentOrFixedType == 'Percentage (%)'">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px blue">
                        <label for="firstName">Discount %</label>
                      </div>
                      <div class="col-md-4">
                        <input type="number" class="form-control" placeholder="Discount Percentage"
                               id="idDiscountGiven"
                               [(ngModel)]="DiscountPercent"
                               (ngModelChange)="ChangeDiscountPercentage(1)"
                               name="idDiscountGiven" 
                               maxlength="4" >                        
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="DiscountPercentOrFixedType == 'Fixed Amount'">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px blue">
                        <label for="firstName">Today's Discount</label>
                      </div>
                      <div class="col-md-4">
                        <input type="number" class="form-control" placeholder="Discount"
                               id="TodaysDiscount"
                               [(ngModel)]="TodaysDiscount" (ngModelChange)="ChangeLFollicle()"
                               name="TodaysDiscount" #Endometrium2="ngModel"
                               maxlength="7" pattern="^[1-9]\d*$" required>
                        <small class="form-text text-danger"
                               *ngIf="(!Endometrium2.valid && (Endometrium2.dirty || Endometrium2.touched) && Endometrium2.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Endometrium2.valid && Endometrium2.errors.pattern)">(only positive numbers are allowed)</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label for="diaplayName" class="margin-bottom-0px">Total Discount </label>
                      </div>
                      <div class="col-md-4">
                        <label class="margin-bottom-0px margin-left-5px">{{TotalDiscount}}</label>
                        <!--<input type="tel" class="form-control" id="CurrentActorAddEmergencyInfoRequest.EmergencyContactNo1"
                 [(ngModel)]="CurrentActorAddEmergencyInfoRequest.EmergencyContactNo1"
                mask="(000) 000-0000"
                 name="CurrentActorAddEmergencyInfoRequest.EmergencyContactNo1" pattern="[0-9]{10}" #EmergencyContactNo1="ngModel"
                 placeholder="Mobile Phone" />
          <small class="form-text text-danger"
                 *ngIf="(!EmergencyContactNo1.valid)">(Provide Valid CellNo)</small>-->
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row margin-top-5px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName">Remarks </label>
                      </div>
                      <div class="col-md-7 ">
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                  name="Remarks"
                                  [(ngModel)]="Remarks" required minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                        <!--<small class="form-text text-danger"
          *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                        <!--id="CurrentActorPersonalDetailInfoRequest.City"
                 [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                 name="CurrentActorPersonalDetailInfoRequest.City"
                  maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
          <small class="form-text text-danger"
                 *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<label>Hyderabad</label>-->
                        <!--<input type="text" class="form-control" id="CurrentActorAddEmergencyInfoRequest.EmergencyAddress"
                 [(ngModel)]="CurrentActorAddEmergencyInfoRequest.EmergencyAddress"
                 name="CurrentActorAddEmergencyInfoRequest.EmergencyAddress"
                 placeholder="City" maxlength="20" minlength="1" #EmergencyAddress="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
          <small class="form-text text-danger"
                 *ngIf="(!EmergencyAddress.valid && (EmergencyAddress.dirty || EmergencyAddress.touched) && EmergencyAddress.errors.required)">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!EmergencyAddress.valid && EmergencyAddress.errors.pattern)">(special characters are not allowed)</small>-->
                      </div>
                    </div>


                  </div>
                </div>




              </div>
            </div>


         

















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
